import { Link } from 'react-router-dom';
import { videos } from '@/mocks/videos';

export default function VideoGrid() {
  const featuredVideos = videos.slice(0, 8);

  return (
    <section className="py-12 md:py-16 bg-background-100/50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-600 mt-1">精选高分内容，总有一部适合你</p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap flex items-center gap-1 cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuredVideos.map((video) => (
            <Link
              key={video.id}
              to={`/category/${video.category}`}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-lg aspect-video bg-background-200 mb-3">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  title={`${video.title} - 在线观看免费高清`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
                  <span className="text-xs text-white bg-primary-500/90 px-2 py-0.5 rounded">
                    {video.quality}
                  </span>
                </div>
                <div className="absolute top-3 left-3">
                  <span className="text-xs text-white bg-black/70 px-2 py-0.5 rounded">
                    {video.duration}
                  </span>
                </div>
                <div className="absolute top-3 right-3 flex items-center gap-1 text-white text-xs bg-black/70 px-2 py-0.5 rounded">
                  <i className="ri-star-fill text-primary-500 text-xs"></i>
                  {video.rating}
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1">
                {video.title}
              </h3>
              <div className="flex items-center gap-3 mt-1.5">
                <span className="text-xs text-foreground-600">{video.year}</span>
                <span className="text-xs text-foreground-600">{video.views}次播放</span>
              </div>
              <div className="flex items-center gap-1.5 mt-2 flex-wrap">
                {video.tags.slice(0, 2).map((tag) => (
                  <span key={tag} className="text-xs px-2 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">
                    {tag}
                  </span>
                ))}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}